import { NgModule  } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { TranslateModule } from '@ngx-translate/core';
import { MatRadioModule } from '@angular/material/radio';
import {MatDialogModule} from '@angular/material/dialog';
import { MatPaginatorIntl } from '@angular/material/paginator';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
// import { SafePipeModule } from 'safe-pipe';

import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';

import { fuseConfig } from 'app/fuse-config';

import { FakeDbService } from 'app/main/fake-db/fake-db.service';
import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';

//wizard de certificar
import { WizardCGOModule } from 'app/main/wizard-cgo/wizard-cgo.module';
import { WizardN35Module } from 'app/main/wizard-n35/wizard-n35.module';
import { WizardN35EncuestadorModule } from './main/wizard-n35encuestador/wizard-n35encuestador.module';
import { WizardLeaderModule } from 'app/main/wizard-leader/wizard-leader.module';
import { WizardActionModule } from 'app/main/wizard-actionGO/wizard-action.module';

//modulo de encuestador
import { EncuestadorModule } from 'app/main/encuestador/encuestador.module';
//modulo de culture audit
import { CultureAuditModule } from 'app/main/pagina/culture-audit/culture-audit.module';
import { PortalConteosModule } from 'app/main/portal-conteos/portal-conteos.module';

//modulo de login
import { LoginModule } from 'app/main/login/login.module';
import { PaginaModule } from 'app/main/pagina/pagina.module';

///IDIOMAS
import { IdiomasModule } from './idiomas/idiomas.module';

///PAGINAS
import { Error404Component } from './main/pagina/landingPages/404/error-404.component';
import { Error500Component } from './main/pagina/landingPages/500/error-500.component';
import { HomeComponent } from './main/pagina/landingPages/home/home.component';
//import { HomePageComponent } from './main/pagina/home/home.component';


//SERVICES
// import { LoginService } from "./main/pagina/certificar/services/login.service";
//validador de estatus autenticado, redirige a login en caso de no estarlo
import { AuthGuard } from 'app/auth/auth.guard';
///intercepta cualquier comunicacion de peticion http e inyecta el token
import { AuthInterceptor } from './auth/auth-interceptor';
///intercepta cualquier comunicacion de peticion http e inyecta el token
import { ErrorInterceptor } from './error-interceptor';
///Modal generico
import { ModalComponent } from './main/pagina/modal/modal.component';

import { AlertDialogComponent } from 'app/main/pagina/certificar/alertdialog/alertdialog.component';

import { LoginService } from './services/login.service';

// LOCALES PARA IDIOMA DE FECHA
import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es';
import localeTR from '@angular/common/locales/tr';
import localeChTr from '@angular/common/locales/zh-Hant';
import localeChSm from '@angular/common/locales/zh-Hans';
import localePt from '@angular/common/locales/pt';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
///graficas lineales
// import { ChartsModule } from 'ng2-charts';
registerLocaleData(localeEsMx, 'es');
registerLocaleData(localeTR, 'tr');
registerLocaleData(localeChTr, 'zh1');
registerLocaleData(localeChSm, 'zh2');
registerLocaleData(localePt, 'pt');

//traduccion para paginador de tablas
import * as tradPaginador from "./services/idioma-paginador";

// Gestures
import {
  HAMMER_GESTURE_CONFIG,
  HammerModule
} from '@angular/platform-browser';

/** Import Alyle UI */
import {
  LyTheme2,
  StyleRenderer,
  LY_THEME,
  LY_THEME_NAME,
  LyHammerGestureConfig
} from '@alyle/ui';

/** Import the component modules */
import { LyButtonModule } from '@alyle/ui/button';
import { LyToolbarModule } from '@alyle/ui/toolbar';
import { LyImageCropperModule } from '@alyle/ui/image-cropper';
import { LySliderModule } from '@alyle/ui/slider';
import { LyIconModule } from '@alyle/ui/icon';
import { LyDialogModule } from '@alyle/ui/dialog';

/** Import themes */
import { MinimaLight, MinimaDark } from '@alyle/ui/themes/minima';

import 'hammerjs';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';

const appRoutes: Routes = [
    {
        path     : '',
        redirectTo: 'home', pathMatch: 'full'
    },
    {
        path     : 'home',
        component: HomeComponent,
        ///añadir esta linea para agregar la validacion de estatus autenticado a cada ruta
        canActivate: [AuthGuard]
    },
    { path: '**',
    redirectTo: 'error-404' },
    {
        path     : 'error-404',
        component: Error404Component,
        canActivate: [AuthGuard]
    }
];

@NgModule({
    declarations: [
        AppComponent,
        Error404Component,
        Error500Component,
        //HomePageComponent,
        ModalComponent,
        AlertDialogComponent
    ],
    imports     : [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' }),

        TranslateModule.forRoot(),
        InMemoryWebApiModule.forRoot(FakeDbService, {
            delay             : 0,
            passThruUnknownUrl: true
        }),

        // Material moment date module
        MatMomentDateModule,

        // Material
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        MatProgressSpinnerModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,
        MatRadioModule,

        // Idiomas
        IdiomasModule,

        // App modules
        // SafePipeModule,
        LayoutModule,
        WizardN35Module,
        WizardCGOModule,
        WizardLeaderModule,
        WizardActionModule,
        WizardN35EncuestadorModule,
        LoginModule,
        PaginaModule,
        EncuestadorModule,
        CultureAuditModule,
        PortalConteosModule,
        //alyle
        LyButtonModule,
        LyToolbarModule,
        LyImageCropperModule,
        LySliderModule,
        LyIconModule,
        // LyDialogModule
        // Gestures
        HammerModule,
        MatGridListModule,
        MatCardModule,
        MatMenuModule
    ],
    providers: [
      //interceptor de peticiones http
      {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
      //interceptor de errores en peticiones http
      {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
      //validador de autenticado o no autenticado
      AuthGuard,
      LoginService,
      // { provide: LOCALE_ID, useValue: 'es' },
      // { provide: LOCALE_ID, useValue: 'en' }
      {provide: LocationStrategy, useClass: HashLocationStrategy},
      // {provide: MatPaginatorIntl, useValue: tradPaginador.getDutchPaginatorIntl() }
      [ LyTheme2 ],
      [ StyleRenderer ],
      // Theme that will be applied to this module
      { provide: LY_THEME_NAME, useValue: 'minima-light' },
      { provide: LY_THEME, useClass: MinimaLight, multi: true }, // name: `minima-light`
      { provide: LY_THEME, useClass: MinimaDark, multi: true }, // name: `minima-dark`
      // Gestures
      { provide: HAMMER_GESTURE_CONFIG, useClass: LyHammerGestureConfig }
    ],
    bootstrap   : [
        AppComponent
    ],
    entryComponents: [
        ModalComponent,
        AlertDialogComponent
    ]
})
export class AppModule
{
}
